import Logo from "../../asset/Logo.jpg";
import { Stack, Box, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthRequest } from "../../util/request/authRequest";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import WaiverList from "./waiver/waiverList";
import GiftcardList from "./giftcard/giftcardList";
// import BookingCalendar from "./booking/bookingCalendar";
import WeeklyCalendar from "../../Components/WeeklyCalendar";
import BookingCalendar from "./booking/bookingCalendar";
import BookingMain from "./booking/bookingMain";
import { over } from "lodash";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
const MainBoard = () => {
  const [value, setValue] = useState(0);
  const [reFresh, setReFresh] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    async function verif() {
      const response = await AuthRequest({ subLink: "auth/verifyToken" });
      //   console.log(response.status);
      //   setAuthResult(response.status);
      //   try {
      //     const response = await AuthRequest({ subLink: "auth/verifyToken" });
      //   } catch (error) {
      //     console.log(error);
      //   }
      if (response.status !== 200) {
        return navigate("/login");
      }
      if (response.status == 200) {
        return navigate("/adminDashboard");
      }
    }
    //   setAuthResult(response.data.status);

    verif();
  }, [reFresh]);

  return (
    <Stack
      direction="column"
      spacing={2}
      justifyContent={"center"}
      sx={{
        justifyContent: "center",
        alignItems: "center",
        Xscroll: "hidden",
        Yscroll: "hidden",
      }}
      maxWidth={"1400px"}
      minWidth={"804px"}
    >
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          height: "6vh",
          width: "100%",
          borderBottom: "1px solid #8525da",
        }}
      >
        <img
          src={Logo}
          alt={"logo"}
          style={{
            maxHeight: "60px",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        />
        <Box>
          <BottomNavigation
            showLabels
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
            sx={{
              "& .Mui-selected, .Mui-selected > svg": {
                color: "#8525da", // Overrides for selected icons
              },
              paddingRight: "30px",
            }}
          >
            <BottomNavigationAction
              label="Waivers"
              icon={<DriveFileRenameOutlineIcon sx={{ fontSize: "30px" }} />}
            />
            <BottomNavigationAction
              label="Booking"
              icon={<EditCalendarIcon sx={{ fontSize: "30px" }} />}
            />
            <BottomNavigationAction
              label="Gift Card"
              icon={<CardGiftcardIcon sx={{ fontSize: "30px" }} />}
            />
            {/* <gif label="Nearby" icon={<LocationOnIcon />} /> */}
          </BottomNavigation>
        </Box>
      </Stack>

      {value === 0 && (
        <Stack
          sx={{
            height: "86vh",
            width: "90%",
          }}
        >
          <WaiverList
            refreshData={() => {
              window.location.reload();
            }}
          />
        </Stack>
      )}

      {value === 1 && (
        <Stack
          sx={{
            height: "86vh",
            width: "90%",
          }}
        >
          <>
            <BookingMain />
            {/* <BookingModal /> */}
          </>
        </Stack>
      )}

      {value === 2 && (
        <Stack
          sx={{
            height: "86vh",
            width: "90%",
          }}
        >
          <GiftcardList />
        </Stack>
      )}
    </Stack>
  );
};

export default MainBoard;
